import React from "react";
import {CheckCircle} from "@material-ui/icons";
import {Grid, MenuItem, Select, TextField} from "material-ui";

import {ItemGrid, RegularCard, Table} from "components";
import {store, oktaSignIn} from "../../index";
import {getPastOrders, storeSelectedPastNumber} from "../../service/pastOrderActions";
import moment from "moment"
import momentDurationFormatSetup from "moment-duration-format"
import {Timer} from "./timer"
import {connect} from "react-redux";
import Button from "../../components/CustomButtons/Button";

export class PastOrderPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            pastOrderDataLoaded: false,
            selectedpastunit: "days",
            activepastunit: "days"
        };
    }

    componentDidMount() {
        this.loadPastOrderData();
    }

    onPastNumberChange = (e) => {
        store.dispatch(storeSelectedPastNumber(e.target.value))
    }

    render() {
        return (
            <Grid container>
                <ItemGrid xs={12} sm={12} md={12}>
                    <TextField
                        maxLength="4"
                        label="how long in past"
                        value={this.props.selectedpastnumber}
                        onChange={this.onPastNumberChange}
                    />

                    &nbsp;

                    <Select
                        value={this.state.selectedpastunit}
                        onChange={this.onUnitChange}
                    >
                        {/*<MenuItem value={"seconds"}>seconds</MenuItem>*/}
                        {/*<MenuItem value={"minutes"}>minutes</MenuItem>*/}
                        {/*<MenuItem value={"hours"}>hours</MenuItem>*/}
                        <MenuItem value={"days"}>days</MenuItem>
                    </Select>

                    &nbsp;
                    &nbsp;

                    <Button color="info" round={false} onClick={() => this.loadPastOrderDataWithReset()}>Submit</Button>

                </ItemGrid>
                <ItemGrid xs={12} sm={12} md={12}>
                    <RegularCard
                        cardTitle="Past Orders"
                        cardSubtitle={this.getCartSubtitle}
                        content={
                            <Table
                                tableHeaderColor="primary"
                                tableHead={["Email", "ParentCartId", "PONumber", "SapCartId", "Status", "SapOrder#", "S3", "Timestamp", "Conclusion"]}
                                tableData={this.getPastOrderData()}
                            />
                        }
                    />
                </ItemGrid>
            </Grid>
        );
    }

    loadPastOrderDataWithReset = () => {
        this.setState({
            pastOrderDataLoaded: false
        });
        this.loadPastOrderData();
    }

    getCartSubtitle = () => {
        return "Order history for last " + this.props.selectedpastnumber + "days"
    }

    loadPastOrderData = () =>  {
        console.log(" Calling for past orders. location.pathname: " + window.location.pathname)
        store.dispatch(getPastOrders(this.props.selectedpastnumber, this.state.selectedpastunit, oktaSignIn.tokenManager.get('access_token').accessToken)).then(() => {
            this.setState({
                pastOrderDataLoaded: true,
                activepastunit: this.state.selectedpastunit
            })
        });
    }

    sortOrder = ["PLACED", 'SUBMITTED', 'ENGAGED', 'CONFIRMED'];

    getLastestState(line) {
        if (!line.sapCartId) {
            return "PLACED";
        } else if (!line.status) {
            return "SUBMITTED";
        } else if (!line.s3) {
            return "ENGAGED";
        } else {
            return "CONFIRMED";
        }
    }

    getTimestamp(line, state) {
        switch (state) {
            case "PLACED":
                return line.placedAt;
            case "SUBMITTED" :
                return line.submittedAt;
            case "ENGAGED" :
                return line.processedAt;
            case "CONFIRMED" :
                return line.confirmedAt;
            default:
                return new Date().getTime();

        }
    }

    getPastOrderData() {
        momentDurationFormatSetup(moment);
        var array = []
        let checkStyle = {
            textAlign: "center",
            width: "100px"
        }
        if (this.props.pastOrderData.map) {
            this.props.pastOrderData.map((line) => {
                let lastestState = this.getLastestState(line);
                let timeStamp = this.getTimestamp(line, lastestState);
                let timeDiff = new Date() - new Date(timeStamp);

                array.push([
                    line.email,
                    line.parentCartId.toString(),
                    line.poNumber.toString(),
                    line.sapCartId ? line.sapCartId : "-",
                    line.status ? line.status : "-",
                    line.saporderNum ? line.saporderNum : "-",
                    typeof line.s3 !== "undefined" ? line.s3.toString() : "-",
                    moment(timeStamp).format("YYYY-MM-DD hh:mm:ss A"),
                    // lastestState,
                    line.status === "Failed" ?  <CheckCircle style={{color: "red", ...checkStyle}}/> :
                        (line.s3? <CheckCircle style={{color: this.getColor(line.s3), ...checkStyle}}/> : <Timer time={timeDiff}></Timer>)
                ])
            })
        }

        // Works minus am/pm
        array.sort((a, b) => {
            return new Date(b[7]) - new Date(a[7]);
        });

        return array
    }

    getColor(s3) {
        if(s3.toLowerCase() === "true")
            return "green";
        else
            return "red";
    }
}

const mapStateToProps = state => {
    return {
        selectedpastnumber: state.pastOrderState.selectedpastnumber,
        pastOrderData: state.pastOrderState.pastOrderData,
        accessToken: state.authState.accessToken
    }
};

const PastOrders = connect(
    mapStateToProps
)(PastOrderPage);


export default PastOrders;



// WEBPACK FOOTER //
// ./src/views/TableList/PastOrders.jsx